/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".row[_ngcontent-%COMP%]{display:flex;margin-right:0;margin-left:0}.closeMdl[_ngcontent-%COMP%]{font-size:17px!important;padding:7px 10px!important;margin-top:5px;position:relative;top:0}.col-md-7[_ngcontent-%COMP%]{max-width:57%!important}.NoItemFound[_ngcontent-%COMP%]{padding:10px 15px;background-color:#9eb6be26;border-radius:25px}.NoItemFound[_ngcontent-%COMP%], .inLneBlk[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };

